<script lang="ts" setup>
import { useEditorElements } from '../hooks/useEditorElements';
import { useGoToPricing } from '../hooks/useGoToPricing';
const { planName } = useEditorElements();
const { pricingUrl } = useGoToPricing();
</script>
<template>
  <div id="sidebar-overlay" class="fixed bottom-0 w-[290px]">
    <div class="h-full w-full bg-dark-400 opacity-70" />
    <div class="box-upgrade-plan flex justify-center rounded-[3px] bg-dark-300 !p-4">
      <img src="../assets/icons/blue-info-icon.svg" alt="" class="!mr-2 !h-5 !w-5" />
      <div class="text-xs font-normal leading-[150%] text-dark-mode-high-contrast">
        You are currently on {{ planName }} plan.
        <a :data-href="pricingUrl" target="_blank" class="gp-open-new-tab font-medium text-blue-250">
          Upgrade your plan
        </a>
        to Optimize plan to unlock all Popup settings.
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
#sidebar-overlay {
  height: calc(100% - 150px);
  backdrop-filter: blur(8px);
  @media (max-width: 1300px) {
    width: 260px;
  }
}
.box-upgrade-plan {
  width: calc(100% - 24px);
  position: absolute;
  top: 12px;
  left: 12px;
}
</style>
